import { omit } from 'lodash/fp';

import { ConfigurationResult } from '@mews-distributor/data-access';
import { createReducer } from '@mews/framework/redux';

import { FETCH_CONFIGURATIONS_SUCCEEDED } from '../configuration/actionTypes';
import { BOOKING_RESTARTED } from '../global/actionTypes';
import { CITY_SELECTED } from '../resourceOrder/actionTypes';
import {
    ANOTHER_HOTEL_SELECTED,
    APP_CLOSED,
    APP_INITIALIZATION_FAILED,
    APP_INITIALIZATION_SUCCEEDED,
    APP_OPENED,
    CURRENCY_CHANGE_FAILED,
    CURRENCY_CHANGE_STARTED,
    CURRENCY_CHANGE_SUCCEEDED,
    IS_FX_MULTICURRENCY_SERVICE_ENABLED_SET,
    LANGUAGE_SET,
    ROUTE_SET,
} from './actionTypes';
import {
    AnotherHotelSelectedPayload,
    CitySelectedPayload,
    CurrencyChangedPayload,
    LanguageSetPayload,
    RouteSetPayload,
} from './payloadTypes';
import { App } from './types';

const INITIAL_STATE = {
    clientApiLanguageCode: null,
    isInvalidIframe: false,
};

export const app = createReducer(INITIAL_STATE, {
    [APP_INITIALIZATION_SUCCEEDED]: (state: App) => ({ ...state, isInitialized: true }),

    [APP_INITIALIZATION_FAILED]: (state: App) => ({ ...state, hasFailed: true }),

    [APP_OPENED]: (state: App) => ({ ...state, isOpened: true }),

    [APP_CLOSED]: (state: App) => ({ ...state, isOpened: false }),

    [LANGUAGE_SET]: (state: App, { languageCode, isClientApiCall = false }: LanguageSetPayload) => ({
        ...state,
        languageCode,
        clientApiLanguageCode: isClientApiCall ? languageCode : state.clientApiLanguageCode,
    }),

    [CURRENCY_CHANGE_STARTED]: (state: App) => ({ ...state, isCurrencyChangeInProgress: true }),

    [CURRENCY_CHANGE_SUCCEEDED]: (state: App, { currencyCode }: CurrencyChangedPayload) => ({
        ...state,
        currencyCode,
        isCurrencyChangeInProgress: false,
    }),

    [CURRENCY_CHANGE_FAILED]: (state: App) => ({ ...state, isCurrencyChangeInProgress: false }),

    [FETCH_CONFIGURATIONS_SUCCEEDED]: (state: App, { currencyCodes }: ConfigurationResult) => ({
        ...state,
        currencyCodes,
    }),

    [ROUTE_SET]: (state: App, { route }: RouteSetPayload) => ({
        ...omit<App, 'anotherHotelId'>('anotherHotelId', state),
        currentRoute: route,
        previousRoute: state.currentRoute,
    }),

    [CITY_SELECTED]: (state: App, { cityId }: CitySelectedPayload) => ({
        ...state,
        selectedCityId: cityId,
        isCityDirty: true,
    }),

    [BOOKING_RESTARTED]: (state: App) => ({
        ...omit('previousRoute', state),
        reservationIdsFromQuery: [],
        reservationGroupIdFromQuery: undefined,
    }),

    [ANOTHER_HOTEL_SELECTED]: (state: App, { hotelId }: AnotherHotelSelectedPayload) => ({
        ...state,
        anotherHotelId: hotelId,
    }),

    [IS_FX_MULTICURRENCY_SERVICE_ENABLED_SET]: (
        state: App,
        { isFxMulticurrencyServiceEnabled }: { isFxMulticurrencyServiceEnabled: boolean }
    ) => ({
        ...state,
        isFxMulticurrencyServiceEnabled,
    }),
});
